/* @flow weak */

'use strict';

const React = require('react');
const _ = require('lodash');

const QuestionStore = require('../../stores/QuestionStore.jsx');
const QuestionGroup = require('./QuestionGroup.jsx');

const Config = require('../../configs/Config.js');
const Omniture = require('../../metrics/walmart/Omniture.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const QuestionGroupRenderer = React.createClass({
  propTypes: {
    questions: React.PropTypes.array
  },

  getInitialState() {
    return {
      activeGroup: 0,
      userClicked: false
    };
  },

  handleOpenGroup(i, l, group) {
    this.setState({
      activeGroup: this.state.activeGroup !== i ? i : '',
      userClicked: true
    }, () => {
      this.handleTracking(i, l, group);
    });
  },

  handleOpenNextGroup(i, l, group) {
    this.setState({
      activeGroup: i < l - 1 ? i + 1 : '',
      userClicked: true
    }, () => {
      this.handleTracking(i, l, group);
    });
  },

  handleTracking(i, l, group) {
    if (_.get(Config, 'omniture.account')) {
      Omniture.questionDetails(i + 1, l, group);
    }
  },

  generateGroups(questions) {
    // Returns an array of group names in the appropriate sort order relative to the questions.
    let groups = _.chain(questions)
      .uniq(function(q) {
        return _.get(q, `metadata.lang.${ln}.QuestionGroup`);
      })
      .pluck('metadata').pluck('lang').pluck(`${ln}`).pluck('QuestionGroup')
      .value();

    // Returns an object. Key = group name. Value = array of question objects.
    let questionsByGroup = _.groupBy(questions, function(q) {
      return _.get(q, `metadata.lang.${ln}.QuestionGroup`);
    });

    let fixedHeaderHeight = Config.fixedHeaderHeightSmall;
    if (window.innerWidth >= Config.breakpoints.small) fixedHeaderHeight = Config.fixedHeaderHeightMedium;
    if (window.innerWidth >= Config.breakpoints.medium) fixedHeaderHeight = Config.fixedHeaderHeightLarge;

    let previousGroupTabIndex = 0;

    return _.map(groups, (group, index) => {
      let groupIndex = groups.indexOf(group);

      if (!this.state.userClicked && groupIndex == 0) {
        this.handleTracking(index, groups.length, group);
      }

      let stepNumber = index + 1;
      let previousGroup = index === 0 ? null : groups[index - 1];
      let previousGroupQuestions = questionsByGroup[previousGroup];
      let previousGroupQuestionCount = _.get(previousGroupQuestions, 'length') || 0;
      let isLastGroup = index === groups.length - 1;

      // go through all questions for previous group and add any child questions to previousGroupQuestionCount
      _.each(previousGroupQuestions, (question) => {
        let childCount = _.get(QuestionStore.getChildQuestions(question.id), 'length');
        previousGroupQuestionCount += childCount;
      });

      let groupTabIndex = index === 0 ? 1 : previousGroupTabIndex + previousGroupQuestionCount + 1;
      previousGroupTabIndex = groupTabIndex;

      return (
        <QuestionGroup
          key={index}
          group={group || 'Other'}
          isLast={isLastGroup}
          stepNumber={stepNumber}
          groupTabIndex={groupTabIndex}
          questions={questionsByGroup[group]}
          active={this.state.activeGroup === groupIndex}
          clickHandler={this.handleOpenGroup.bind(null, index, groups.length, group)}
          clickNextButtonHandler={this.handleOpenNextGroup.bind(null, index, groups.length, group)}
          to={'uc-question-group-' + index + 1}
          offset={-fixedHeaderHeight}
          name={'uc-question-group-' + index + 1}
          smooth={true}
          duration={300}
          userClicked={this.state.userClicked} />
      );
    });
  },

  render() {
    return (
      <div id='uc-question-groups' className='uc-question-groups'>
        {this.generateGroups(this.props.questions)}
      </div>
    );
  }
});

module.exports = QuestionGroupRenderer;


// WEBPACK FOOTER //
// ./src/base/scripts/components/renderers/QuestionGroupRenderer.jsx